import CheckboxTreeFilter from "./CheckboxTreeFilter";

class QuaterViewReviewFilter extends CheckboxTreeFilter {
  chipLabelTransform = (x: string) => {
    if (x === "null") {
      return "No";
    }
    return x;
  };
}

export default QuaterViewReviewFilter;
